declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    __gtmLoaded?: boolean;
  }
}

const GTM_ID = "GTM-KWPXD65J";

export const loadAnalytics = () => {
  if (typeof window === "undefined" || window.__gtmLoaded) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  window.__gtmLoaded = true;
};

export const pushEvent = (event: string, data?: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};

export const pushConsent = (analytics: boolean, marketing: boolean) => {
  pushEvent('consent_update', { analytics, marketing });
};
